import React from 'react';
import './ConfirmationModel.css';

const ConfirmationModel = ({ isOpen, onClose, onConfirm, title, children, confirmText = "Konfirmasi" }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h3>{title}</h3>
                <p>{children}</p>
                <div className="modal-actions">
                    <button onClick={onClose} className="modal-button cancel">Batal</button>
                    <button onClick={onConfirm} className="modal-button confirm">{confirmText}</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModel;